import { GivelifyNotification } from 'pages/signup/components/GivelifyNotification/GivelifyNotification';
import { Content } from './Content';
import { Header } from './Header';
import { PageWrapper } from './style';
import { useEffect, useMemo, useState } from 'react';
import { useInvokeApi } from 'pages/signup/utils/useInvokeApi';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { useTranslation } from 'react-i18next';
import { webConfig } from 'webConfig';
import { pushEvent } from 'utils/clevertapUtils';
import {
    CLICK_CONGRATS_PAGE_RESEND_BTN,
    CLICK_CONGRATS_PAGE_SUPPORT_BTN,
    VIEW_CONGRATS_PAGE,
} from 'utils/clevertapEvents';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes';

export const ViewV2: React.FC<any> = () => {
    const { userEmail, fingerprint } = useSelector((state: AppState) => ({
        userEmail: state.Signup.userEmail,
        fingerprint: state.Signup.fingerprint,
    }));
    const [open, setOpen] = useState<boolean>(false);
    const [lastResend, setLastResend] = useState<number>(0);

    const [resendRequest, makeRequest] = useInvokeApi();
    const push = useNavigate();
    const { t } = useTranslation();
    const copy = useMemo(
        () => ({
            weSent: t('signup.submitted.weSent'),
        }),
        [t],
    );

    const handleResend = () => {
        pushEvent(CLICK_CONGRATS_PAGE_RESEND_BTN, {
            gp_signup_verification_ui: 'on',
        });
        setOpen(false);
        const currentTime = new Date().getTime();
        if (!lastResend || currentTime - lastResend >= 60 * 1000) {
            setLastResend(currentTime);
            makeRequest('POST', 'signup/resend-verification', {
                email: userEmail,
                user_key: fingerprint,
            });
        } else {
            setOpen(true);
        }
    };
    const handleSupport = () => {
        pushEvent(CLICK_CONGRATS_PAGE_SUPPORT_BTN, {
            gp_signup_verification_ui: 'on',
        });
        window.open(webConfig.supportFormURL, '_blank');
    };

    useEffect(() => {
        pushEvent(VIEW_CONGRATS_PAGE, { gp_signup_verification_ui: 'on' });
    }, []);

    useEffect(() => {
        if (
            resendRequest.type === 'REQUEST_SUCCESS' ||
            resendRequest.type === 'REQUEST_ERROR'
        ) {
            setOpen(true);
        }
    }, [resendRequest]);

    if (!userEmail) {
        push(PATH.SIGNUP.HOME);
        return null;
    }

    return (
        <PageWrapper>
            <Header />
            <Content
                onResend={handleResend}
                onSupport={handleSupport}
                email={userEmail}
            />
            <GivelifyNotification
                isOpen={open}
                text={`${copy.weSent} ${userEmail}`}
                onClose={() => setOpen(false)}
            />
        </PageWrapper>
    );
};
